import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AdministrationModule } from './administration/administration.module';
import { InformationTechnologyModule } from './information-technology/information-technology.module';

import { HomePageComponent } from './component/home-page/home-page.component';
import { AccountSummaryComponent } from './component/account-summary/account-summary.component';
import { RegistrationComponent } from './component/registration/registration.component';
import { EmailValidationComponent } from './component/email-validation/email-validation.component';
import { CheckEmailComponent } from './component/check-email/check-email.component';
import { EmailSuccessComponent } from './component/email-success/email-success.component';
import { BillingCreditCardComponent } from './component/billing-credit-card/billing-credit-card.component';
import { BillingAddressComponent } from './component/billing-address/billing-address.component';
import { LoginComponent } from './component/login/login.component';
import { ForgotPasswordComponent } from './component/forgot-password/forgot-password.component';
import { EditCreditCardComponent } from './component/edit-credit-card/edit-credit-card.component';
import { AccountsCardPageComponent } from './component/accounts-card-page/accounts-card-page.component';
import { EditAccountCardsComponent } from './component/edit-account-cards/edit-account-cards.component';
import { AccountDetailComponent } from './component/account-detail/account-detail.component';
import { ChangeCurrencyComponent } from './component/change-currency/change-currency.component';
import { ConfirmPaymentComponent } from './component/confirm-payment/confirm-payment.component';
import { AutoLoginComponent } from './component/auto-login/auto-login.component';
import { RenewalAmountComponent } from './component/renewal-amount/renewal-amount.component';
import { EditCreditCardsComponent } from './component/edit-credit-cards/edit-credit-cards.component';
import { ManageProfileComponent } from './component/manage-profile/manage-profile.component';
import { MakePaymentComponent } from './component/make-payment/make-payment.component';
import { PaymentHistoryComponent } from './component/payment-history/payment-history.component';
import { UpdateForgottenPasswordComponent } from './component/update-forgotten-password/update-forgotten-password.component';
import { CustomerServiceComponent } from './component/customer-service/customer-service.component';
import { FrequentlyAskedQuestionsComponent } from './component/frequently-asked-questions/frequently-asked-questions.component';
import { EmailValidationResendComponent } from './component/email-validation-resend/email-validation-resend.component';

import { AuthGuardService } from '@core/services';
import { ITGroupGuard } from '@core/guards';

const appRoutes: Routes = [
    {
        path: '',
        component: HomePageComponent,
        pathMatch: 'full'
    },
    {
        path: 'account',
        component: AccountSummaryComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'registration',
        component: RegistrationComponent
    },
    {
        path: 'checkemail',
        component: CheckEmailComponent
    },
    {
        path: 'emailsuccess',
        component: EmailSuccessComponent
    },
    {
        path: 'emailvalidation/:token',
        component: EmailValidationComponent
    },
    {
        path: 'emailvalidation/:token/:id',
        component: EmailValidationComponent
    },
    {
        path: 'emailvalidationresend',
        component: EmailValidationResendComponent
    },
    {
        path: 'addcreditcard',
        component: BillingCreditCardComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'editbilling',
        component: BillingAddressComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'editcreditcard',
        component: EditCreditCardComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'accountsetup',
        component: AccountsCardPageComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'accountdetail/:id',
        component: AccountDetailComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'accountdetail',
        component: AccountDetailComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'changecurrency',
        component: ChangeCurrencyComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'confirmpayment',
        component: ConfirmPaymentComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'editcards',
        component: EditAccountCardsComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'forgotpassword',
        component: ForgotPasswordComponent
    },
    {
        path: 'autologin',
        component: AutoLoginComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'renewalamount',
        component: RenewalAmountComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'editcreditcards',
        component: EditCreditCardsComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'manageprofile',
        component: ManageProfileComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'manageprofile/:tab',
        component: ManageProfileComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'makepayment',
        component: MakePaymentComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'paymenthistory',
        component: PaymentHistoryComponent,
        canActivate: [AuthGuardService]
    },
    {
        path: 'updateforgottenpassword/:token/:id',
        component: UpdateForgottenPasswordComponent,
    },
    {
      path: 'customerservice',
      component: CustomerServiceComponent,
      canActivate: [AuthGuardService]
    },
    {
      path: 'customerservice/:type',
      component: CustomerServiceComponent,
      canActivate: [AuthGuardService]
    },
    {
        path: 'faq',
        component: FrequentlyAskedQuestionsComponent,
    },

    // FOR THE LAZY LOADED ADMINISTRATION MODULE THAT I CREATED
    {
      path: 'administration',
      canActivate: [AuthGuardService],
      loadChildren: './administration/administration.module#AdministrationModule'
    },
    {
      path: 'it',
      canActivate: [AuthGuardService, ITGroupGuard],
      loadChildren: './information-technology/information-technology.module#InformationTechnologyModule'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule]
})

export class AppRoutingModule {
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/app.routing.module.ts